<template>
  <div class="header-banner noSelect">
    <div class="header-banner-content">

      <div class="banner-item">
        <div class="banner-item-top">
          <img class="banner-item-icon" :src="IMG_URL+'images/icons/tongzhi.png'" alt="">
          <h3 class="banner-item-title">最新公告</h3>
        </div>
        <div class="news-list">
          <div class="news-item" v-for="(item, index) in noticeList" :key="index" @click="onJumpDetail(item.id)">{{index+1}}.{{item.title}}</div>
        </div>
      </div>

      <div class="banner-image">
        <img :src="API_URL+advert.images" alt="" @click="onJumpPages(advert.link)">
      </div>

      <div class="banner-item">
        <div class="banner-item-top">
          <img class="banner-item-icon" :src="IMG_URL+'/images/icons/lianxikefu.png'" alt="">
          <h3 class="banner-item-title">在线客服</h3>
        </div>
        
        <img class="vcode-icon" :src="API_URL+site.weixin_qrcode" alt="">
      </div>

      <div class="fix">
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "headerBanner",
  props: {
    noticeList: {
      type: Array,
      default: function (val){
        return val || []
      }
    },
    advert:{
      type: Object,
      default: (val) => {
        return val || {link: "", images: ""}
      }
    }
  },
  data(){
    return{

    }
  },
  computed:{
    site(){
      return this.$store.getters.site;
    }
  },
  methods:{
    onJumpPages(url){
      if(url){
        this.$router.push(url);
      }
    },
    onJumpDetail(id){
      this.$router.push("/news/detail?id="+id+"&type=article")
    },
  }
}
</script>

<style scoped lang="scss">
.fix{
  position: absolute;
  top: 100px;
  margin-left: -20px;
  width: 210px;
  height: 60px;
  background-size: 100% 100%;
  cursor: pointer;
}
.header-banner{
  min-width: 1300px;
  height: 300px;
  background-color: #0f375a;

  .header-banner-content{
    width: 1300px;
    height: 300px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .banner-item{
      width: 200px;
      height: 230px;
      background-color: rgba(0,0,0,0.4);
      box-sizing: border-box;
      padding: 20px;

      .banner-item-top{
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        .banner-item-icon{
          width: 18px;
          height: 18px;
          margin-right: 8px;
        }
        .banner-item-title{
          margin: 0;
          font-size: 16px;
          color: #ffffff;
          font-weight: bolder;
        }
      }

      .news-list{
        height: 160px;
        //overflow-y: auto;

        .news-item{
          font-size: 14px;
          color: #ffffff;
          margin-bottom: 8px;
          cursor: pointer;
          overflow:hidden; text-overflow:ellipsis; white-space:nowrap;

          &:hover{
            color: #0f375a;
          }
        }
      }

      .vcode-icon{
        width: 160px;
        height: 160px;
      }
    }

    .banner-image{
      flex: 1;
      margin: 0 30px;

      img{
        width: 100%;
        height: 230px;
        display: block;
      }


    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/components/headerBanner/index.vue